import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import { AcceptedInvitationResponse } from '../../models/invitation-response.model';

@Component({
  selector: 'app-application-denied',
  templateUrl: './application-denied.component.html',
  styleUrl: './application-denied.component.scss'
})
export class ApplicationDeniedComponent {
  private readonly router = inject(Router);
  public data: AcceptedInvitationResponse | null;

  constructor() {
    const navigation = this.router.getCurrentNavigation();
    this.data = navigation?.extras?.state as AcceptedInvitationResponse ?? null;
  }
}
